import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=39fcd121"
import script from "./AppColorPicker.vue?vue&type=script&lang=js"
export * from "./AppColorPicker.vue?vue&type=script&lang=js"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&id=39fcd121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports